module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/5-c5f30c3196bb47776544584b59fea5fc.svg";